"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.linkPropType = exports.imagePropType = exports["default"] = exports.ctaPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var ctaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.ctaPropType = ctaPropType;
var linkPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.linkPropType = linkPropType;
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  componentLabel: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  heading2: _propTypes["default"].string,
  heading3: _propTypes["default"].string,
  textBlock: _propTypes["default"].string,
  textBlockPosition: _propTypes["default"].string,
  featureBlock: _propTypes["default"].array,
  cta: ctaPropType,
  link: linkPropType,
  image: imagePropType,
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;